<div class="contact-us-container flex justify-between flex-row">
    <app-contact-us-form class="flex-1" (submitSuccess)="showSuccessDialog()"></app-contact-us-form>
    <app-carousel class="flex-1 max-xl:hidden" style="width: 50%"></app-carousel>
    <p-dialog [(visible)]="displaySuccessDialog" header="" [modal]="true" [style]="{ width: '600px' }">
        <div class="dialog-content flex flex-col items-center">
            <div>
                <img src="assets/images/contact-us-success.svg" alt="" />
            </div>
            <div class="title">Thank you for your message!</div>
            <div class="description">We’ve successfully received your request and will process it shortly. Our team will contact you as soon as possible.</div>
            <div class="footer w-full flex justify-center items-center gap-[24px]">
                <button class="w-full primary" (click)="displaySuccessDialog = false">Close</button>
            </div>
        </div>
    </p-dialog>
</div>
